
import Vue from 'vue'

Vue.directive('uppercase', {
  bind(el, _, vnode) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
    })
  },
})

Vue.directive('lowercase', {
  bind(el, _, vnode) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value.toLowerCase()
      vnode.componentInstance.$emit('input', e.target.value.toLowerCase())
    })
  },
})


// WEBPACK FOOTER //
// ./src/directives/index.js